import { SearchInput } from "@hub/ui/components/SearchInput";
import { Badge } from "@hub/ui/components/ui/badge";

interface QueueFiltersProps {
  activeStatus: string | null;
  onStatusChange: (status: string | null) => void;
  search: string;
  onSearchChange: (search: string) => void;
  statusCounts: Record<string, number>;
}

const statusTabs = [
  { key: null, label: "All" },
  { key: "open", label: "Open" },
  { key: "in_progress", label: "In Progress" },
];

export function QueueFilters({
  activeStatus,
  onStatusChange,
  search,
  onSearchChange,
  statusCounts,
}: QueueFiltersProps) {
  return (
    <div className="space-y-3 p-3 border-b border-gray-200 dark:border-white/10">
      <div className="flex gap-1">
        {statusTabs.map((tab) => {
          const isActive = activeStatus === tab.key;
          const count = tab.key ? (statusCounts[tab.key] ?? 0) : Object.values(statusCounts).reduce((a, b) => a + b, 0);

          return (
            <button
              key={tab.key ?? "all"}
              onClick={() => onStatusChange(tab.key)}
              className={`
                flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium rounded-md transition-colors
                ${
                  isActive
                    ? "bg-coronis-blue-600 text-white"
                    : "text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-white/10"
                }
              `}
            >
              {tab.label}
              <Badge
                variant="secondary"
                className={`text-xs px-1.5 py-0 ${
                  isActive ? "bg-white/20 text-white" : ""
                }`}
              >
                {count}
              </Badge>
            </button>
          );
        })}
      </div>

      <SearchInput
        value={search}
        onChange={onSearchChange}
        placeholder="Search by patient, claim, type..."
      />
    </div>
  );
}
